import { z } from 'zod'

import type { ZodSimplify } from '@mntn-dev/utility-types'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import { DollarsSchema } from './property.models.ts'
import {
  ServiceDomainSelectModelSchema,
  ServicePayoutSchema,
  ServiceTypeSchema,
} from './service.models.ts'
import { TagFilterSchema } from './tag.models.ts'
import {
  PackageIdSchema,
  PackageServiceIdSchema,
  ServiceIdSchema,
} from './unique-id.models.ts'

/**
 * Count
 */
export const PackageServiceCountSchema = z.number().int().positive()
export type PackageServiceCount = ZodSimplify<typeof PackageServiceCountSchema>

/**
 * PackageServiceDomainSelectModel
 */
export const PackageServiceDomainSelectModelSchema =
  ServiceDomainSelectModelSchema.omit({ status: true }).extend({
    isArchived: z.boolean().optional(),
    packageServiceId: PackageServiceIdSchema,
    packageId: PackageIdSchema,
    serviceType: ServiceTypeSchema,
    cost: ServicePayoutSchema.optional(),
    costPlusMargin: DollarsSchema().optional(),
    count: PackageServiceCountSchema,
  })

export type PackageServiceDomainSelectModel = ZodSimplify<
  typeof PackageServiceDomainSelectModelSchema
>

/**
 * PackageServiceDomainInsertModel
 */
export const PackageServiceDomainInsertModelSchema =
  PackageServiceDomainSelectModelSchema.omit({ costPlusMargin: true })
    .extend({
      cost: PackageServiceDomainSelectModelSchema.shape.cost.nullable(),
    })
    .partial({ packageServiceId: true })

export type PackageServiceDomainInsertModel = ZodSimplify<
  typeof PackageServiceDomainInsertModelSchema
>

/**
 * PackageServiceDomainUpdateModel
 */
export const PackageServiceDomainUpdateModelSchema =
  PackageServiceDomainSelectModelSchema.pick({
    serviceType: true,
    count: true,
    name: true,
    description: true,
    max: true,
    isArchived: true,
  })
    .extend({
      cost: PackageServiceDomainSelectModelSchema.shape.cost.nullable(),
    })
    .partial()

export type PackageServiceDomainUpdateModel = ZodSimplify<
  typeof PackageServiceDomainUpdateModelSchema
>

/**
 * PackageServiceDomainSelectModelFilters
 */
export const PackageServiceDomainSelectModelFiltersSchema = z
  .object({
    isArchived: z.boolean(),
    packageServiceId: ModelFilterSchema(PackageServiceIdSchema),
    packageId: ModelFilterSchema(PackageIdSchema),
    serviceId: ModelFilterSchema(ServiceIdSchema),
    serviceType: ModelFilterSchema(ServiceTypeSchema),
    tags: TagFilterSchema,
  })
  .partial()

export type PackageServiceDomainSelectModelFilters = ZodSimplify<
  typeof PackageServiceDomainSelectModelFiltersSchema
>
